import React from 'react';
import styles from './CardsList.module.less';
import DynamicCard, { CardEcmContent } from '../../components/CardsList/DynamicCard';

type EcmCardsListProps = {
  title: string;
  subTitle?: string;
  layoutType?: string;
  layoutStyles?: React.CSSProperties;
  style?: React.CSSProperties;
  cardType: string;
  cards: Array<CardEcmContent>;
};

type CardsListProps = {
  ecmContent: EcmCardsListProps;
};

const defaultStyles: Record<string, React.CSSProperties> = {
  horizontal: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px' },
  vertical: { display: 'flex', flexDirection: 'column', gap: '16px' },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr));',
    gap: '16px'
  },
  default: { display: 'flex', gap: '16px' }
};

const CardsList = ({ ecmContent }: CardsListProps) => {
  const {
    title,
    subTitle,
    layoutType,
    layoutStyles: ecmLayoutStyles = {},
    style: ecmCardsListStyles = {},
    cards = [],
    cardType
  } = ecmContent || {};

  if (cards.length === 0) return null;

  // Fetch styles from ECM based on layoutType, fallback to default styles
  const layoutStyles =
    ecmLayoutStyles && Object.keys(ecmLayoutStyles).length
      ? ecmLayoutStyles
      : defaultStyles[layoutType || 'default'];

  return (
    <div className={styles.card_list_container} style={ecmCardsListStyles}>
      <p className={styles.card_list_title}>{title}</p>
      {subTitle && <p className={styles.card_list_subtitle}>{subTitle}</p>}
      <div className={styles.card_section_container} style={{ ...layoutStyles }}>
        {cards.map((card) => (
          <DynamicCard key={card.title} ecmContent={card} listCardType={cardType} />
        ))}
      </div>
    </div>
  );
};

export default CardsList;
